module.exports = __webpack_public_path__ + "static/media/95.cd43b4b7.gif";